export default __webpack_public_path__ + "static/stape-7601d93ba29061a9972fbf1e8d371e91.png";